<template>
  <div id="container" class="contain">
    <div class="mainBox" :height="appHeight">
      <el-form
        class="login-box"
        ref="loginForm"
        :model="form"
        :rules="rules"
        label-width="80px"
        :style="{ marginTop: marginTop }"
      >
        <div style="margin: 0px auto; height: 12px">
          <el-avatar
            :size="50"
            :src="require('@/assets/mtlogo.png')"
            class="appLogo"
          ></el-avatar>
        </div>
        <h3 class="login-title">{{ webTitle }}</h3>
        <!-- <el-form-item label="部  门" prop="userdeptId">
          <el-select
            ref="userdept"
            v-model="form.userdeptId"
            name="userdept"
            placeholder="请选择部门"
            tabindex="1"
            @change="changeUser"
            autocomplete="on"
          >
            <el-option
              v-for="item in userdeptList"
              :key="item.rybm"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="人  员" prop="username">
          <el-select
            ref="username"
            v-model="form.username"
            name="username"
            placeholder="请选择姓名"
            tabindex="2"
            autocomplete="on"
          >
            <el-option
              v-for="item in userList"
              :key="item.rybm"
              :label="item.name"
              :value="item.login"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

         <el-form-item label="账号" prop="username">
          <!-- 子label定制内容格式 -->
          <label slot="label">账&nbsp;&nbsp;&nbsp;&nbsp;号</label>
          <el-input type="text" placeholder="请输入账号" v-model="form.username" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <label slot="label">密&nbsp;&nbsp;&nbsp;&nbsp;码</label>
          <el-input type="password" placeholder="请输入密码" v-model="form.password" />
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="verifyCode"
          class="verifyCodeItemCss"
        >
          <el-input
            class="verify_css"
            placeholder="请输入验证码"
            v-model="form.verifyCode"
            @keyup.enter.native="onSubmit('loginForm')"
          ></el-input>
          <img
            :src="codeUrl"
            v-on:click="getCode"
            class="login-code-img"
            style="
              position: absolute;
              float: right;
              min-height: 40px;
              right: 10%;
              border-radius: 0px 3px 3px 0px;
              cursor: pointer;
            "
          />
          <div class="login-code"></div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            v-on:click="onSubmit('loginForm')"
            style="float: right; margin-right: 60px"
            >登录</el-button
          >
        </el-form-item>
      </el-form>

      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <span>请输入账号和密码</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div ref="footer" style="position: fixed; bottom: 0px">sss</div>
  </div>
</template>


<script>
import Vue from "vue";
import {
  getUserDeptListApi,
  getUserListApi,
  loginByUsername,
  logout,
  getUserInfo,
  vierfiyCode,
  getToken,
} from "@/api/login.js";
import config from "@/config.js";

export default {
  name: "Login",
  data() {
    return {
      webTitle: config.webTitle,
      appHeight: "",
      marginTop: "150px",
      userdeptList: [],
      userList: [],
      userLogin: "",
      codeUrl: "",
      form: {
        userdeptId: "",
        username: "",
        password: "",
        verifyCode: "",
        userType:"salesman"
      },

      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        userdeptId: [
          { required: true, message: "部门不可为空", trigger: "change" },
        ],
        username: [
          { required: true, message: "姓名不可为空", trigger: "change" },
        ],
        password: [
          { required: true, message: "密码不可为空", trigger: "change" },
        ],
        verifyCode: [
          { required: true, message: "验证码不可为空", trigger: "blur" },
        ],
      },

      // 对话框显示和隐藏
      dialogVisible: false,
    };
  },
  created() {
     //sessionStorage.removeItem("token");
     getToken({appID:config.appID}).then(response => {
        if(response.data.code == 20000){
          sessionStorage.setItem("token",response.data.data.token);
          // this.getUserDeptList();
          this.getCode();
        }
      })
    //this.codeUrl = "http://localhost:1500/dev-api/session/vierfiyCode?"+ Math.random();
    // if(!sessionStorage.getItem("token")){
    //   getToken({appID:config.appID}).then(response => {
    //     if(response.data.code == 20000){
    //       sessionStorage.setItem("token",response.data.data.token);
    //     }
    //   })
    // }
    //this.getUserDeptList();
    //this.getCode();
    // vierfiyCode().then(response =>{
    //  //this.codeUrl = response;
    //  this.codeUrl = "data:image/gif;base64," + response.data;
    //  // this.loginForm.uuid = res.uuid;
    // })
  },
  mounted() {
    this.appHeight = this.$refs["footer"].offsetTop + "px";
    this.marginTop = this.$refs["footer"].offsetTop / 2 - 200 + "px";
    //console.log()
  },
  methods: {
    getCode() {
      this.codeUrl = null;
      vierfiyCode().then((res) => {
        //var img = document.createElement('img')
        const myBlob = new window.Blob([res.data], { type: "image/gif" });
        const qrUrl = window.URL.createObjectURL(myBlob);
        // img.src = qrUrl
        // img.onload = function () {
        //     window.URL.revokeObjectURL(qrUrl)
        // }
        // const imgDiv = document.querySelector('#flow-img')
        // imgDiv.appendChild(img)
        this.codeUrl = qrUrl;
      });
      //alert("sss")
      //this.codeUrl = "http://localhost:1500/dev-api/session/vierfiyCode?"+ Math.random();
    },
    onSubmit(formName) {
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 使用 vue-router 路由到指定页面，该方式称之为编程式导航
          //this.$router.push("/main");
          let that = this;
          loginByUsername(this.form).then((response) => {
            if (response.data.code == 20000) {
              this.$message({ message: "登陆成功！", type: "success" });
              Vue.prototype.LoginState = true;
              //sessionStorage.setItem("token",JSON.stringify(response.data.data.token))
              //sessionStorage.setItem("token",response.data.data.token);
              sessionStorage.setItem("username", response.data.data.realname);

              if (Vue.prototype.LoginState == true)
              this.$router.push({ path: this.redirect || "/" }); //到定向页或者主页
            } else {
              this.$alert(response.data.message, "错误信息", { type: "error" });
              this.getCode();
            }
            
          });
        } else {
          this.dialogVisible = true;
          return false;
        }
      });
    },
    getUserDeptList: function () {
      getUserDeptListApi({}).then((response) => {
        //console.log(response);
        this.userdeptList = response.data.data;
      });
      //  this.$http.post(this.SERVER_URL + "/session/getUserDeptList", {}).then(response => {
      //    this.userdeptList = response.body.data;
      //  })
    },
    changeUser() {
      this.form.username = "";
      let query = {
        id: this.form.userdeptId,
      };
      getUserListApi(query).then((response) => {
        this.userList = response.data.data;
      });
    },
    handleClose: function () {
      this.dialogVisible = false;
    },
  },
};
</script>


<style type="text/css" scoped>
.contain {
  background-color: transparent !important;
}
.mainBox {
  max-width: 1000px;
  margin: 0px auto 10px auto;
  /* background-color: #fffdf7; */
  /* border-style: dotted;
    border-width: thin; */
  padding: 10px 10px;
  border-color: gainsboro;
  border-radius: 10px;
}
.login-box {
  border: 1px solid #dcdfe6;
  width: 98%;
  margin: 180px auto;
  max-width: 450px;
  padding: 36px 0px 0px 0px;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  box-shadow: 2px 5px 0px 0px #c7c7c7;
  background-color: rgb(255, 255, 255);
  display: block !important;
  /* z-index: 10; */
}

.login-title {
  text-align: center;
  margin: 0 auto 20px auto;
  color: #303133;
  position: relative;
  top: -10px;
  /* left:7% */
}

.appLogo {
  position: relative;
  left: 5%;
  top: -10px;
  /* z-index: 1; */
}

.el-select {
  width: 90%;
}
.el-input {
  width: 90%;
}
.el-dialog {
  min-width: 330px;
}
/* .el-select-dropdown.el-popper{
    min-width: 68% !important;
    max-width: 70% !important;
  } */
</style>




// WEBPACK FOOTER //
// src/components/login.vue